import { render, staticRenderFns } from "./formList.vue?vue&type=template&id=fda4bbd2&scoped=true&"
import script from "./formList.vue?vue&type=script&lang=ts&"
export * from "./formList.vue?vue&type=script&lang=ts&"
import style0 from "./formList.vue?vue&type=style&index=0&id=fda4bbd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda4bbd2",
  null
  
)

export default component.exports